import React, { useEffect, useState, useRef } from "react";
import DefaultLayout from "../../layouts/defaultLayout";
import "./style.css";

import { useLocation, useNavigate } from "react-router-dom";
import axios from "axios";
import { toast } from "react-toastify";
import { BASE_URL } from "../../constants";
import { Loader } from "rsuite";
import { addition } from "../../assets/svgIcons";
import { Input } from "../../components/form-elements";
import Modal from "../../components/modal";
import TextArea from "../../components/form-elements/textarea";
import { userData } from "../../data/fake_login_data";
import { perms } from "../../data/side_nav_data";
import { exportToCSV } from "../../functions";
import PageHeader from "../../components/page-header";
import StatsCards from "../../components/stats-cards";
import ShowHideModal from "../../components/show-hide-modal";
const ChainsCourses = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const [searchHeaderKet, setSearchHeaderKey] = useState('');
  const [showAdd, setShowAdd] = useState(false);
  const [courseName, setCourseName] = useState(false);
  const [courseLogo, setCourseLogo] = useState(false);
  const [courseDescription, setCourseDescription] = useState(false);
  const [data, setData] = useState(false);
  const [loading, setLoading] = useState(false);
  const [showActions, setShowActions] = useState(false);
  const [deleteId, setDeleteId] = useState(false);
  const [editId, setEditId] = useState(false);
  const [filteredData, setFilteredData] = useState(false);
  useEffect(() => {
    fetchData();
  }, []);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (showActions && !event.target.closest('.course-actions')) {
        setShowActions(false);
      }
    };

    if (showActions) {
      document.addEventListener('click', handleClickOutside);
      return () => document.removeEventListener('click', handleClickOutside);
    }
  }, [showActions]);
  const fetchData = async () => {
    try {
      const response = await axios.post(
        BASE_URL + "courses/courses/select_course_chain.php",
        {
          chain_id: location?.state?.chain_id,
          admin_id: userData?.user_id,
          access_token: userData?.access_token,
        }
      );
      setData(response?.data?.message);
    } catch (err) {
      setData([]);
      toast.error(err?.message);
    }
  };
  const addCourse = async (e) => {
    e.preventDefault();
    setLoading(true);
    const form = e.target;
    const formData = new FormData();
    formData.append("image", courseLogo);
    try {
      const imageUpload = await axios.post(
        BASE_URL + "item_img_uploader.php",
        formData
      );
      if (imageUpload?.data?.status == "success") {
        const response = await axios.post(
          BASE_URL + "courses/courses/insert_course.php",
          {
            chain_id: location?.state?.chain_id,
            course_name: courseName,
            course_photo: imageUpload?.data?.message,
            course_description: courseDescription,
            university_id: location?.state?.university_id,
            admin_id: userData?.user_id,
            access_token: userData?.access_token,
          }
        );

        if (response.data?.status == "success") {
          toast.success(response.data?.message);
          fetchData();
          setShowAdd(false);
          setCourseLogo(null);
          setCourseName(null);
          form.reset();
          setLoading(false);
        } else {
          setLoading(false);
          toast.error(response.data?.message);
        }
      } else {
        setCourseLogo(false);
        toast.error("Failed on Upload Image");
        setLoading(false);
      }
      // setShowAdd(false);
    } catch (err) {
      toast.error(err?.message);
      setLoading(false);
    }
  };
  const editCourse = async (e) => {
    e.preventDefault();
    setLoading(true);
    const form = e.target;
    const formData = new FormData();
    formData.append("image", courseLogo);
    try {
      const imageUpload = await axios.post(
        BASE_URL + "item_img_uploader.php",
        formData
      );
      if (
        imageUpload?.data?.status == "success" ||
        !courseLogo ||
        editId?.course_photo
      ) {
        const response = await axios.post(
          BASE_URL + "courses/courses/update_course_new.php",
          {
            course_id: editId?.course_id,
            chain_id: location?.state?.chain_id,
            course_photo:
              imageUpload?.data?.message &&
              imageUpload?.data?.message?.length &&
              courseLogo
                ? imageUpload?.data?.message
                : editId?.course_photo,
            course_name: courseName ? courseName : editId?.course_name,
            course_description: courseDescription
              ? courseDescription
              : editId?.course_description,
            admin_id: userData?.user_id,
            access_token: userData?.access_token,
          }
        );
        if (response.data?.status == "success") {
          fetchData();
          setEditId(false);
          setCourseLogo(null);
          setCourseName(null);
          form.reset();
          setLoading(false);
          toast.success(response.data?.message);
        } else {
          setLoading(false);
          toast.error(response.data?.message);
        }
      } else {
        setCourseLogo(false);
        toast.error("Failed on Upload Image");
        setLoading(false);
      }
      // setShowAdd(false);
    } catch (err) {
      toast.error(err?.message);
      setLoading(false);
    }
  };
  const handleDeleteCourse = () => {
    const data_send = {
      course_id: deleteId?.course_id,
      admin_id: userData?.user_id,
      access_token: userData?.access_token,
      hidden: deleteId?.hidden == "no" ? "yes" : "no",
    };
    axios
      .post(BASE_URL + "courses/courses/show_hide_course.php", JSON.stringify(data_send), {
        headers: {
          "Content-Type": "Application/Json",
        },
      })
      .then((res) => {
        if (res.data.status == 'success') {
          toast.success(res.data.massage);
          setDeleteId(false);
          fetchData();
        } else if (res.data.status == 'error') {
          toast.error(res.data.massage);
        } else {
          toast.error("Something Went Error");
        }
      });
  };
  useEffect(() => {
    if (searchHeaderKet && searchHeaderKet?.length) {
      setFilteredData(
        data?.filter(
          (item) =>
            item?.course_id == searchHeaderKet ||
            item?.course_name?.includes(searchHeaderKet) ||
            item?.course_description?.includes(searchHeaderKet)
        )
      );
    } else {
      setFilteredData(data);
    }
  }, [searchHeaderKet, data]); // Use a Set to keep track of unique items
  if (!location?.state?.chain_id) {
    navigate(-1);
  }

  return (
    <div id="home">
      <DefaultLayout
        setSearchHeaderKey={setSearchHeaderKey}
        children={
          <>

            <PageHeader
              title={"Courses For Chain (" + location.state?.chain_name + ")"}
              description="Manage course information and settings"
              exportButton={
                perms?.includes("*17_13") || perms?.startsWith("17_13")
                  ? true
                  : false
              }
              deleteButton={
                perms?.includes("*4_2") || perms?.startsWith("4_2")
                  ? true
                  : false
              }
              addButton="Add Course"
              data={data}
              setShowAdd={setShowAdd}

              addition={
                perms?.includes("*4_2") || perms?.startsWith("4_2")
                  ? addition
                  : null
              }
            />
            <StatsCards data={data} title="Courses" icon={addition} />
            <div className="filters_box">
              {/* <div className="orderby"> */}
              {/* <input type="text" id="orderBy" /> */}
              {/* </div> */}
            </div>
            {!data && !filteredData ? (
              <Loader />
            ) : data?.length && filteredData?.length ? (
              <div className="course_Container">
                {filteredData?.map((item) => {
                  return (
                    <div className="course-card">
                      <div className="course-image-container">
                      <img
                        src={item?.course_photo}
                          alt={item?.course_name}
                          className="course-image"
                        onClick={() =>
                          perms?.includes("*4_1") || perms?.startsWith("4_1")
                            ? navigate("chapters", {
                                state: {
                                  university_id: location?.state?.university_id,
                                  grade_id: location?.state?.grade_id,
                                  course_id: item?.course_id,
                                  chain_id: location?.state?.chain_id,
                                  course_name: item?.course_name,
                                },
                              })
                            : null
                        }
                      />
                        <div className="course-overlay">
                          <div className="course-status">
                            <span className={`status-badge ${item?.hidden === "no" ? "active" : "inactive"}`}>
                              {item?.hidden === "no" ? "Active" : "Hidden"}
                            </span>
                          </div>
                        </div>
                      </div>

                      <div className="course-content">
                        <div className="course-header">
                          <h3
                            className="course-title"
                          onClick={() =>
                            perms?.includes("*4_1") || perms?.startsWith("4_1")
                              ? navigate("chapters", {
                                  state: {
                                    university_id: location?.state?.university_id,
                                    grade_id: location?.state?.grade_id,
                                    course_id: item?.course_id,
                                    chain_id: location?.state?.chain_id,
                                    course_name: item?.course_name,
                                  },
                                })
                              : null
                          }
                        >
                          {item?.course_name}
                          </h3>
                          <div className="course-actions">
                            <button
                              className="action-toggle"
                            onClick={() => {
                              setShowActions(
                                showActions !== item?.course_id
                                  ? item?.course_id
                                  : false
                              );
                            }}
                          >
                              <svg width="20" height="20" viewBox="0 0 24 24" fill="currentColor">
                                <circle cx="12" cy="6" r="2" />
                                <circle cx="12" cy="12" r="2" />
                                <circle cx="12" cy="18" r="2" />
                              </svg>
                            </button>
                            {item?.course_id == showActions && (
                              <div className="course-actions-menu">
                                {perms?.includes("*4_3") || perms?.startsWith("4_3") ? (
                                  <button
                                    className="action-btn edit-btn"
                                    onClick={() => {
                                      setEditId(item);
                                      setShowActions(false);
                                    }}
                                  >
                                    <svg width="16" height="16" viewBox="0 0 24 24" fill="currentColor">
                                      <path d="M3 17.25V21h3.75L17.81 9.94l-3.75-3.75L3 17.25zM20.71 7.04c.39-.39.39-1.02 0-1.41l-2.34-2.34c-.39-.39-1.02-.39-1.41 0l-1.83 1.83 3.75 3.75 1.83-1.83z" />
                                    </svg>
                                    Edit Course
                                  </button>
                                ) : null}

                                <button
                                  className="action-btn toggle-btn"
                                  onClick={() => {
                                    setDeleteId(item);
                                    setShowActions(false);
                                  }}
                                >
                                  <svg width="16" height="16" viewBox="0 0 24 24" fill="currentColor">
                                    <path d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm-2 15l-5-5 1.41-1.41L10 14.17l7.59-7.59L19 8l-9 9z" />
                                  </svg>
                                  {item?.hidden == "no" ? "Hide Course" : "Show Course"}
                                </button>

                                {perms?.includes("*4_6") || perms?.startsWith("4_6") ? (
                                  <button
                                    className="action-btn subscription-btn"
                                    onClick={() => {
                                      navigate("subscriptions", {
                                        state: {
                                          chain_id: location?.state?.chain_id,
                                          university_id: location?.state?.university_id,
                                          grade_id: location?.state?.grade_id,
                                          course_id: item?.course_id,
                                          course_name: item?.course_name,
                                        },
                                      });
                                      setShowActions(false);
                                    }}
                                  >
                                    <svg width="16" height="16" viewBox="0 0 24 24" fill="currentColor">
                                      <path d="M12 2l3.09 6.26L22 9.27l-5 4.87 1.18 6.88L12 17.77l-6.18 3.25L7 14.14 2 9.27l6.91-1.01L12 2z" />
                                    </svg>
                                    Subscriptions
                                </button>
                              ) : null}

                              <button
                                  className="action-btn cards-btn"
                                  onClick={() => {
                                    navigate("ChainsCoursesCards", {
                                      state: {
                                        chain_id: location?.state?.chain_id,
                                        university_id: location?.state?.university_id,
                                        grade_id: location?.state?.grade_id,
                                        course_id: item?.course_id,
                                        course_name: item?.course_name,
                                      },
                                    });
                                    setShowActions(false);
                                  }}
                                >
                                  <svg width="16" height="16" viewBox="0 0 24 24" fill="currentColor">
                                    <path d="M19 3H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm-5 14H7v-2h7v2zm3-4H7v-2h10v2zm0-4H7V7h10v2z" />
                                  </svg>
                                  Course Cards
                                </button>

                                {perms?.includes("*4_7") || perms?.startsWith("4_7") ? (
                                  <button
                                    className="action-btn quiz-btn"
                                    onClick={() => {
                                    navigate("quizzes", {
                                      state: {
                                        chain_id: location?.state?.chain_id,
                                          university_id: location?.state?.university_id,
                                        grade_id: location?.state?.grade_id,
                                        course_id: item?.course_id,
                                        course_name: item?.course_name,
                                      },
                                      });
                                      setShowActions(false);
                                    }}
                                  >
                                    <svg width="16" height="16" viewBox="0 0 24 24" fill="currentColor">
                                      <path d="M9 11H7v6h2v-6zm4 0h-2v6h2v-6zm4 0h-2v6h2v-6zm2.5-9H19V1h-2v1H7V1H5v1H4.5C3.67 2 3 2.67 3 3.5v15c0 .83.67 1.5 1.5 1.5h15c.83 0 1.5-.67 1.5-1.5v-15c0-.83-.67-1.5-1.5-1.5zM19 18.5H5v-12h14v12z" />
                                    </svg>
                                    Quizzes
                                  </button>
                              ) : null}

                                {perms?.includes("*4_8") || perms?.startsWith("4_8") ? (
                                  <button
                                    className="action-btn notification-btn"
                                  onClick={() => {
                                    navigate("cournot", { data: item });
                                      setShowActions(false);
                                  }}
                                >
                                    <svg width="16" height="16" viewBox="0 0 24 24" fill="currentColor">
                                      <path d="M12 22c1.1 0 2-.9 2-2h-4c0 1.1.9 2 2 2zm6-6v-5c0-3.07-1.64-5.64-4.5-6.32V4c0-.83-.67-1.5-1.5-1.5s-1.5.67-1.5 1.5v.68C7.63 5.36 6 7.92 6 11v5l-2 2v1h16v-1l-2-2z" />
                                    </svg>
                                  Notifications
                                  </button>
                              ) : null}
                            </div>
                            )}
                          </div>
                        </div>

                      <p
                          className="course-description"
                        onClick={() =>
                          perms?.includes("*4_1") || perms?.startsWith("4_1")
                            ? navigate("chapters", {
                                state: {
                                  university_id: location?.state?.university_id,
                                  grade_id: location?.state?.grade_id,
                                  course_id: item?.course_id,
                                  chain_id: location?.state?.chain_id,
                                  course_name: item?.course_name,
                                },
                              })
                            : null
                        }
                      >
                        {item?.course_description}
                      </p>

                        <div className="course-footer">
                          <div className="course-category">
                            <span className="category-badge">Course</span>
                          </div>
                        {perms?.includes("*4_5") || perms?.startsWith("4_5") ? (
                          <button
                              className="auto-subscription-btn w-fit "
                            onClick={() =>
                              navigate("phonelist", {
                                state: {
                                  chain_id: location?.state?.chain_id,
                                  university_id: location?.state?.university_id,
                                  grade_id: location?.state?.grade_id,
                                  course_id: item?.course_id,
                                  course_name: item?.course_name,
                                },
                              })
                            }
                          >
                              <svg width="16" height="16" viewBox="0 0 24 24" fill="currentColor">
                                <path d="M6.62 10.79c1.44 2.83 3.76 5.14 6.59 6.59l2.2-2.2c.27-.27.67-.36 1.02-.24 1.12.37 2.33.57 3.57.57.55 0 1 .45 1 1V20c0 .55-.45 1-1 1-9.39 0-17-7.61-17-17 0-.55.45-1 1-1h3.5c.55 0 1 .45 1 1 0 1.25.2 2.45.57 3.57.11.35.03.74-.25 1.02l-2.2 2.2z" />
                              </svg>
                              Auto Subscription
                          </button>
                        ) : null}
                        </div>
                      </div>
                    </div>
                  );
                })}
              </div>
            ) : (
              <h4>No Courses</h4>
            )}
          </>
        }
      />
      <Modal
        headerTitle={"Add Course"}
        open={showAdd}
        toggle={setShowAdd}
        children={
          <form
            action="#"
            onSubmit={!loading ? addCourse : (e) => e.preventDefault()}
          >
            <div className="inputField">
              <label htmlFor="course_name">Course Name</label>
              <Input
                type={"text"}
                id={"course_name"}
                name={"course_name"}
                onChange={(e) => setCourseName(e.value)}
              />
            </div>
            <div className="inputField">
              <label htmlFor="course_description">Course description</label>
              <TextArea
                type={"text"}
                id={"course_description"}
                name={"course_description"}
                onChange={(e) => setCourseDescription(e.value)}
              />
            </div>
            <div className="inputField">
              <label htmlFor="course_Logo">Course Logo</label>
              <Input
                type={"file"}
                id={"course_Logo"}
                name={"course_Logo"}
                onChange={(e) => setCourseLogo(e.files[0])}
                showImage={true}
              />
            </div>

            <div className="modal-button-container">
              <button className="modal-btn modal-btn-primary">
                {loading ? (
                  <div className="button-loading">
                    <div className="spinner"></div>
                    <span>Saving...</span>
                  </div>
                ) : (
                  <div className="button-content">
                    <svg width="20" height="20" viewBox="0 0 24 24" fill="currentColor">
                      <path d="M17 3H5c-1.11 0-2 .9-2 2v14c0 1.1.89 2 2 2h14c1.1 0 2-.9 2-2V7l-4-4zm-5 16c-1.66 0-3-1.34-3-3s1.34-3 3-3 3 1.34 3 3-1.34 3-3 3zm3-10H5V5h10v4z"/>
                    </svg>
                    <span>Save Course</span>
                  </div>
                )}
            </button>
            </div>
          </form>
        }
      />
      <Modal
        headerTitle={"Edit Course"}
        open={editId}
        toggle={setEditId}
        children={
          <form
            action="#"
            onSubmit={!loading ? editCourse : (e) => e.preventDefault()}
          >
            <div className="inputField">
              <label htmlFor="course_name">Course Name</label>
              <Input
                type={"text"}
                id={"course_name"}
                name={"course_name"}
                defaultValue={editId?.course_name}
                onChange={(e) => setCourseName(e.value)}
              />
            </div>
            <div className="inputField">
              <label htmlFor="course_description">Course description</label>
              <TextArea
                type={"text"}
                id={"course_description"}
                name={"course_description"}
                defaultValue={editId?.course_description}
                onChange={(e) => setCourseDescription(e.value)}
              />
            </div>
            <div className="inputField">
              <label htmlFor="course_Logo">Course Logo</label>
              <Input
                type={"file"}
                id={"course_Logo"}
                name={"course_Logo"}
                onChange={(e) => setCourseLogo(e.files[0])}
                showImage={true}
              />
            </div>

            <div className="modal-button-container">
              <button className="modal-btn modal-btn-primary">
                {loading ? (
                  <div className="button-loading">
                    <div className="spinner"></div>
                    <span>Saving...</span>
                  </div>
                ) : (
                  <div className="button-content">
                    <svg width="20" height="20" viewBox="0 0 24 24" fill="currentColor">
                      <path d="M17 3H5c-1.11 0-2 .9-2 2v14c0 1.1.89 2 2 2h14c1.1 0 2-.9 2-2V7l-4-4zm-5 16c-1.66 0-3-1.34-3-3s1.34-3 3-3 3 1.34 3 3-1.34 3-3 3zm3-10H5V5h10v4z"/>
                    </svg>
                    <span>Save Course</span>
                  </div>
                )}
            </button>
            </div>
          </form>
        }
      />
      <Modal
        open={deleteId}
        toggle={setDeleteId}
        headerTitle={"Show / Hide Course"}
        children={
          <ShowHideModal
            hiddenId={deleteId}
            setHiddenId={setDeleteId} 
            hidden={deleteId?.status === "yes" ? true : false}
            loading={loading}
            hideUniv={handleDeleteCourse}
            title="Course"
          />  
        }
      />
    </div>
  );
};

export default ChainsCourses;
